import { useState, useEffect } from "react";
import { ReserGuaranteeCodes, SaveReserGuaranteeCodes } from "../../Services/Service";

import swal from "sweetalert";
import ReservationSidebar from "../Commun/ReservationSidebar";
import ReservationHeader from "../Commun/ReservationHeader";
import { useProperty } from "../../PropertyContext";

export const ReservationGuaranteeCodes = () => {
    const { selectedProperty } = useProperty();
    const [guaranteeCodes, setGuaranteeCodes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([{ code: "", name: "" }]);

    useEffect(() => {
        const fetchGuaranteeCodes = async () => {
            setLoading(true);
            try {
                const data = await ReserGuaranteeCodes(selectedProperty?.PropertyID);
                if (Array.isArray(data)) setGuaranteeCodes(data);
            } catch (error) {
                console.log("Error fetching business sources:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchGuaranteeCodes();
    }, [selectedProperty]);


    const handleAddRow = () => {
        setRows([...rows, { code: "", name: "" }]);
    };

    const handleDeleteRow = (index) => {
        setRows(rows.filter((_, i) => i !== index));
    };



    const handleChange = (index, field, value) => {
        const newRows = [...rows];
        newRows[index][field] = value;
        setRows(newRows);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            for (let row of rows) {
                if (!row.code || !row.name) {
                    swal("Please Enter Code and Business Source !", {
                        icon: "warning",
                        buttons: {
                            confirm: { text: "OK", className: "btn btn-warning" },
                        },
                    });
                    setLoading(false);
                    return; // Stop execution
                }
            }
            // Loop through all rows and send each one to the API
            for (let row of rows) {
                const formdata = {
                    ID: 0, // or whatever ID you need
                    Code: row.code,
                    GuaranteeCodes: row.name,
                    PropID: selectedProperty?.PropertyID,
                };
                await SaveReserGuaranteeCodes(formdata);
            }

            swal("Business Source added successfully!", {
                icon: "success",
                buttons: {
                    confirm: { text: "OK", className: "btn btn-success" },
                },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("Add-Business-Source")
                );
                modal.hide();
            });

            // Reset rows
            setRows([{ code: "", name: "" }]);

            // Refresh the list
            const data = await ReserGuaranteeCodes(selectedProperty?.PropertyID);
            if (Array.isArray(data)) setGuaranteeCodes(data);

        } catch (error) {
            console.log("Error saving Business Source", error);
            alert("Failed to save Business Source");
        } finally {
            setLoading(false);
        }
    };


    const [editData, setEditData] = useState({
        ID: 0,
        Code: "",
        guaranteeCodes: "",
        PropID: selectedProperty?.PropertyID,
    });


    const handleUpdate = async () => {
        setLoading(true);
        try {
            // Build payload exactly as backend expects (capitalized GuaranteeCodes)
            const payload = {
                ID: editData.ID,
                Code: editData.Code,
                GuaranteeCodes: editData.guaranteeCodes,
                PropID: editData.PropID ?? selectedProperty?.PropertyID ?? 0
            };

            console.log("Update payload:", payload);
            await SaveReserGuaranteeCodes(payload); // send to API

            swal("Business Source updated successfully!", {
                icon: "success",
                buttons: { confirm: { text: "OK", className: "btn btn-success" } },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("Update-Business-Source")
                );
                if (modal) modal.hide();
            });

            // Refresh the list
            const data = await ReserGuaranteeCodes(selectedProperty?.PropertyID);
            if (Array.isArray(data)) {
                setGuaranteeCodes(data.map(d => ({
                    ...d,
                    guaranteeCodes: d.GuaranteeCodes ?? d.guaranteeCodes ?? ""
                })));
            }

        } catch (error) {
            console.log("Error updating Business Source", error);
            alert("Failed to update Business Source");
        } finally {
            setLoading(false);
        }
    };



    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">Business Source List</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <div className="text-end mb-2">
                                                    <button type="button" className="btn btn-primary btn-sm waves-effect waves-light mt-1" data-bs-toggle="modal" data-bs-target="#Add-Business-Source">Add </button>
                                                </div>
                                                <table
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>Code</th>
                                                            <th>Business Source</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {guaranteeCodes && guaranteeCodes.length > 0 ? (
                                                            guaranteeCodes.map((item, index) => (
                                                                <tr key={item.ID || index}>
                                                                    <td>{item.Code}</td>
                                                                    <td>{item.guaranteeCodes}</td>
                                                                    <td>
                                                                        <button type="button" className="btn btn-primary btn-sm waves-effect waves-light py-1 px-2" data-bs-toggle="modal" data-bs-target="#Update-Business-Source"
                                                                            onClick={() => setEditData({
                                                                                ID: item.ID,
                                                                                Code: item.Code,
                                                                                guaranteeCodes: item.GuaranteeCodes ?? item.guaranteeCodes ?? "",
                                                                                PropID: item.PropID ?? selectedProperty?.PropertyID ?? 0,
                                                                            })}><i className="fas fa-edit"></i></button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center">
                                                                    No data found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* sumbit Business Source modal content */}
                    <div
                        id="Add-Business-Source"
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Add Business Source</h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body" style={{ maxHeight: "460px", overflowY: "auto" }}>
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "152px" }}>Code</th>
                                                <th>Business Source</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map((row, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Code"
                                                            value={row.code}
                                                            onChange={(e) =>
                                                                handleChange(index, "code", e.target.value)
                                                            }
                                                            name="code[1,2,3,5]"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Business Source"
                                                            value={row.name}
                                                            onChange={(e) =>
                                                                handleChange(index, "name", e.target.value)
                                                            }
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        {index !== 0 && (
                                                            <button
                                                                className="btn btn-sm text-danger fs-6"
                                                                onClick={() => handleDeleteRow(index)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="text-end">
                                        <button className="btn btn-sm btn-primary" onClick={handleAddRow}>
                                            Add
                                        </button>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-info waves-effect waves-light"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* /.modal */}

                    {/* update Business */}
                    <div
                        id="Update-Business-Source"
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Update Business Source</h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>

                                <div className="modal-body" >
                                    <div className="mb-3">
                                        <label className="form-label">Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editData.Code}
                                            onChange={(e) => setEditData({ ...editData, Code: e.target.value })}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Business Source</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editData.guaranteeCodes}
                                            onChange={(e) => setEditData({ ...editData, guaranteeCodes: e.target.value })}
                                        />
                                    </div>

                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-info waves-effect waves-light"
                                        onClick={handleUpdate}
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}
